import axios from '../request/http';
import {toFormData} from '../common/descriptions'

const info = {
    //   获取用户列表
    getUserList(params) {
        return axios.get("/admin/user/list", { params });
    },
    // 修改用户余额
    updateMoney(params) {
        return axios.get("/admin/user/update/money", { params });
    },
    // 修改用户累计消费
    spendMoney(params) {
        return axios.get("/admin/user/update/spend-money", { params });
    },
    // 获取提现列表
    cashList(params) {
        return axios.get("/admin/cash/list", { params });
    },
    // 通过提现
    cashAccept(data) {
        return axios.post("/admin/cash/accept",  data );
    },
    // 拒绝提现
    cashReject(data) {
        return axios.post("/admin/cash/reject",  data );
    },
    // 获取banner列表
    bannerList(params) {
        return axios.get("/admin/operation/banner/list", { params });
    },
    // 编辑banner
    editBanner(data) {
        return axios.post("/admin/operation/banner/edit",  data );
    },
      // 删除banner
      bannerUpdate(params) {
        return axios.get("/admin/operation/banner/update", { params });
    },
 // 首页主图列表
 indexImgList(params) {
    return axios.get("/admin/operation/index-img/list", { params });
},
  // 编辑banner
  indexImgEdit(data) {
    return axios.post("/admin/operation/index-img/edit",  data );
},
 // 首页主图删除
 indexImgUpdate(params) {
    return axios.get("/admin/operation/index-img/update", { params });
},

}

export default info;


// WEBPACK FOOTER //
// ./src/api/info.js